import dayjs from 'dayjs';
import { DataModel } from '../models/dto/dto.js';
import { OnlinePaymentDetails } from '../models/serializable/online-payment-details.js';
import { PaymentType } from '../models/serializable/payment-type.js';
import { PaymentStatus } from '../models/serializable/payment-status.js';
import { Language } from '../models/serializable/language.js';
import { PaymentMethod } from '../models/serializable/payment-method.js';
import { BusinessModuleRef } from '../models/serializable/business-module-ref.js';
import { TimeZoneRegion } from '../models/serializable/time-zone-region.js';
import { CustomerAccountBase } from '../models/serializable/customer-account-base.js';
import { CustomerProfile } from '../models/serializable/customer-profile.js';
import { Country } from '../models/serializable/country.js';
import { OrderDomain } from '../models/serializable/order-domain.js';
import { OrderSource } from '../models/serializable/order-source.js';

export abstract class CustomerOrderBase extends DataModel {
  abstract get uniqueId(): string;
  abstract get businessRef(): BusinessModuleRef;
  abstract get creatorId(): string;
  abstract get customerId(): string | null;
  abstract get userId(): string | null;
  abstract get language(): Language | null;
  abstract get country(): Country;
  abstract get timezone(): TimeZoneRegion;
  abstract get source(): OrderSource;
  abstract get domain(): OrderDomain;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get cancelledDate(): dayjs.Dayjs | null;
  abstract get cancelledBy(): string | null;

  abstract get isGuestOrder(): boolean;
  abstract get isOpen(): boolean;
  abstract get isCanceled(): boolean;
  abstract get paymentType(): PaymentType | null;
  abstract get paymentMethod(): PaymentMethod | null;
  abstract get onlinePaymentDetails(): OnlinePaymentDetails | null;

  abstract copyWithPaymentDetails(paymentDetails: OnlinePaymentDetails): this;
  abstract copyWithPaymentStatus(status: PaymentStatus): this;
  abstract copyWithPaymentMethod(paymentMethod: PaymentMethod): this;
  abstract assignToCustomerAccount(account: CustomerAccountBase): this;
  abstract tryGetCustomer(): CustomerProfile | null;
}

export abstract class LegacyCustomerOrderBase extends CustomerOrderBase {
  // workaround because javashit doesn't have proper classes and won't trigger type errors without it!
  abstract get isLegacyOrder(): true;

  static assertType(order: CustomerOrderBase): order is LegacyCustomerOrderBase {
    if('isLegacyOrder' in order) {
      const flag = order.isLegacyOrder;
      if(typeof flag === 'boolean') {
        return flag;
      }
    }

    return false;
  }
}
